import React, { useContext } from 'react';
import { noop } from 'lodash';
import GetAppIcon from '@material-ui/icons/GetApp';
import MuiButton from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  DetailContext,
  DetailHandle,
  FilesContext,
  SnackbarContext,
  SnackbarVariant,
} from '@eas/common-web';
import { UForm } from '../../models';
import { useRedirectLink } from '../uform-new/step-finish/step-finish-content';
import { UFormState } from '../../models/uform';
import { sendUForm } from './uform-api';

const useStyles = makeStyles({
  actionbarButton: {
    // height: 25,
    minWidth: 40,
    width: 'max-content',
    cursor: 'pointer',
    // padding: '0px 10px',
    marginTop: 1,
    marginLeft: 6,
    backgroundColor: '#e0e0e0',
    border: 0,
    // textTransform: 'none',
    '&:hover': {
      backgroundColor: '#d0d0d0',
    },
  },
  actionbarMainButton: {
    // height: 25,
    minWidth: 40,
    whiteSpace: 'nowrap',
    width: 'max-content',
    cursor: 'pointer',
    // padding: '0px 10px',
    marginTop: 1,
    marginLeft: 6,
    border: 0,
    // textTransform: 'none',
    boxShadow: '0 0 0',
    color: 'white',
  },
});

export function UFormActionbar() {
  const classes = useStyles();
  const { getFileUrl } = useContext(FilesContext);
  const { showSnackbar } = useContext(SnackbarContext);

  const { source } = useContext<DetailHandle<UForm>>(DetailContext);

  const redirectUrl = useRedirectLink(source.data);

  const isAuthorized = source.data?.state === UFormState.AUTHORIZED;

  const isMZP = source?.data?.recipient?.authority?.code === '00164801';

  const handleSendUForm = async (uformId?: string, using?: 'ESSL' | 'ISDS') => {
    if (!uformId) {
      console.error('UForm id is empty!');
      console.error(source?.data);
      return;
    }
    const response = await sendUForm(uformId, using);
    if (response.ok) {
      showSnackbar(
        'Žádost bude odeslána, stav bude aktualizován v průběhu několika minut.',
        SnackbarVariant.SUCCESS
      );
    } else {
      showSnackbar('Žádost se nepodařilo odeslat.', SnackbarVariant.ERROR);
    }
  };

  return (
    <div style={{ flexWrap: 'wrap' }}>
      {source.data?.pdfFile?.file?.id && (
        <MuiButton
          startIcon={<GetAppIcon />}
          classes={{ root: classes.actionbarButton }}
          onClick={noop}
          download={true}
          href={getFileUrl(source.data.pdfFile.file.id)}
          variant="outlined"
          size="small"
        >
          <Typography variant="body2">Stáhnout PDF</Typography>
        </MuiButton>
      )}
      {!source.data?.certificate?.file?.id && !isAuthorized && (
        <MuiButton
          classes={{ root: classes.actionbarMainButton }}
          onClick={noop}
          variant="contained"
          size="small"
          color="primary"
          href={redirectUrl}
        >
          <Typography variant="body2">Autorizovat</Typography>
        </MuiButton>
      )}

      {isAuthorized && (
        <MuiButton
          classes={{ root: classes.actionbarMainButton }}
          onClick={() => {
            handleSendUForm(source?.data?.id, isMZP ? 'ESSL' : 'ISDS');
          }}
          variant="contained"
          size="small"
          color="primary"
        >
          <Typography variant="body2">
            {isMZP ? 'Odeslat na MŽP' : 'Odeslat přes CRŽP'}
          </Typography>
        </MuiButton>
      )}
      {source.data?.certificate?.file?.file?.id && (
        <MuiButton
          startIcon={<GetAppIcon />}
          classes={{ root: classes.actionbarButton }}
          onClick={noop}
          download={true}
          href={getFileUrl(source.data?.certificate?.file?.file?.id)}
          variant="outlined"
          size="small"
        >
          <Typography variant="body2">Stáhnout osvědčení</Typography>
        </MuiButton>
      )}
    </div>
  );
}
